<template>
    <div></div>
</template>

<script>
export default {
    name: "OpenBookingPaySuccess",
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '支付成功')
        const query = this.$router.currentRoute.query
        if ((!query.payMentId || query.payMentId == '') && !query.paymentId || query.paymentId == '') {
            return this.$router.push({
                name: "BookingListPage"
            })
        }
        let paymentId = query.payMentId
        if (!paymentId || paymentId == '') {
            paymentId = query.paymentId
        }

        location.href=`${process.env.VUE_APP_BASE_URL}${process.env.VUE_APP_OPBK_PAY_SUCCESS_URL}?paymentId=${paymentId}&PromotionCampaign=fixedCoupon&PromotionProduct=3`

    }
}
</script>